export default "__VITE_ASSET__BjXbW4Uk__"